import { toast } from "sonner";
import {
  ApiResponse,
  Listing,
  ListingFilters,
  ListingsResponse,
} from "../types";
import { listingsApi } from "./listings-api";
import { convertListingToPropertyType } from "../utils/propertyTypeUtils";

// Configuration flag for mock vs. real data
export const USE_MOCK_DATA = false;

// Re-export the original functions with the same signature for backward compatibility
export const fetchListings = async (params: ListingFilters = {}) => {
  try {
    const result = await listingsApi.getListings(params);
    const apiResponse = result as ApiResponse<ListingsResponse>;

    if (!apiResponse.data || !apiResponse.data.properties) {
      throw new Error("Invalid API response format");
    }

    return {
      properties: apiResponse.data.properties,
      pagination: {
        totalItems: apiResponse.data.pagination.totalItems,
        totalPages: apiResponse.data.pagination.totalPages,
        currentPage: apiResponse.data.pagination.currentPage,
        itemsPerPage: apiResponse.data.pagination.itemsPerPage,
      },
    };
  } catch (error) {
    throw error; // Re-throw the error for react-query to handle
  }
};

export const fetchListingById = async (id: string) => {
  try {
    const result = await listingsApi.getListing(id);

    // Return the full API response
    return result;
  } catch (error) {
    throw error; // Re-throw the error for react-query to handle
  }
};

// Additional helper function to convert listing to property type
export const fetchPropertyTypeById = async (id: string) => {
  const listing = await fetchListingById(id);
  if (!listing?.data?.listing) return null;

  return convertListingToPropertyType(listing.data.listing);
};
